export const DEFAULT_PARKS_SORT = "videosCount:DESC";
export const getParksQueryFromCtx = (ctx)=>{
    const tags = Array.isArray(ctx.query.tags) ? ctx.query.tags : (ctx.query.tags || "").split(",");
    const states = Array.isArray(ctx.query.states) ? ctx.query.states : (ctx.query.states || "").split(",");
    const type = ctx.query.type || null;
    const sortBy = ctx.query.sortBy || DEFAULT_PARKS_SORT;
    return {
        tags: tags.filter((tag)=>tag).map((tag)=>decodeURIComponent(tag)),
        states: states.filter((state)=>state).map((state)=>decodeURIComponent(state)),
        sortBy,
        type
    };
};
